module.exports = __webpack_public_path__ + "static/media/syllabus.a9eddfdd.svg";